/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：26__part-2
 */

"use strict"

import * as /* [auto-meaningful-name] */Src_shared_packages_Crc_blink_src_index from /* 17 */"../../../../../src/shared/packages/@crc/blink/src/index"
import * as /* [auto-meaningful-name] */Module_659 from /* 659 */"./659"
import /* [auto-meaningful-name] */Module_6591 from /* 659 */"./659"
import * as /* [auto-meaningful-name] */Module_660 from /* 660 */"./660"
import /* [auto-meaningful-name] */Module_6601 from /* 660 */"./660"
import * as /* [auto-meaningful-name] */Module_661 from /* 661 */"./661"
import /* [auto-meaningful-name] */Module_6611 from /* 661 */"./661"
import * as /* [auto-meaningful-name] */Module_662 from /* 662 */"./662"
import /* [auto-meaningful-name] */Module_6621 from /* 662 */"./662"
import * as /* [auto-meaningful-name] */Module_663 from /* 663 */"./663"
import /* [auto-meaningful-name] */Module_6631 from /* 663 */"./663"
import * as /* [auto-meaningful-name] */Module_664 from /* 664 */"./664"
import /* [auto-meaningful-name] */Module_6641 from /* 664 */"./664"
import * as /* [auto-meaningful-name] */Module_665 from /* 665 */"./665"
import /* [auto-meaningful-name] */Module_6651 from /* 665 */"./665"
import * as /* [auto-meaningful-name] */Module_666 from /* 666 */"./666"
import /* [auto-meaningful-name] */Module_6661 from /* 666 */"./666"
import * as /* [auto-meaningful-name] */Module_667 from /* 667 */"./667"
import /* [auto-meaningful-name] */Module_6671 from /* 667 */"./667"
import * as /* [auto-meaningful-name] */Module_668 from /* 668 */"./668"
import /* [auto-meaningful-name] */Module_6681 from /* 668 */"./668"
import * as /* [auto-meaningful-name] */Module_669 from /* 669 */"./669"
import /* [auto-meaningful-name] */Module_6691 from /* 669 */"./669"
import * as /* [auto-meaningful-name] */Module_670 from /* 670 */"./670"
import /* [auto-meaningful-name] */Module_6701 from /* 670 */"./670"
import * as /* [auto-meaningful-name] */Module_671 from /* 671 */"./671"
import /* [auto-meaningful-name] */Module_6711 from /* 671 */"./671"
var W = {
  BLOCK_CLOUD_ICON: Module_6591,
  BLOCK_CLOUD_VARIABLE_ICON: Module_6601,
  BLOCK_PHONE_SHAKE_ICON: Module_6611,
  BLOCK_INPUT_ICON: Module_6621,
  BLOCK_INTERNET_ICON: Module_6631,
  BLOCK_SMS_ICON: Module_6641,
  BLOCK_PHONE_ICON: Module_6651,
  BLOCK_TAB_ICON: Module_6661,
  BLOCK_PEDOMETER_ICON: Module_6671,
  BLOCK_LIST_ICON: Module_6681,
  BLOCK_DICT_ICON: Module_6691,
  BLOCK_CLOUD_DICT_ICON: Module_6701,
  BLOCK_CLOUD_TABLE_ICON: Module_6711
}
var U = function () {
  for (var e in W) Src_shared_packages_Crc_blink_src_index.Blink.Msg[e] = W[e]
}
export { U }
